import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class CharitraService {
  pageSize = 100;
  constructor(private httpClient: HttpClient) { }


  get(input: LeelaInputParameters): Observable<Pagination> {
    return this.httpClient.post<Pagination>(Constants.charitra, input);
  }
}

export class LeelaInputParameters {
  constructor() { }
  ltype: Ltype = 0;
  pageSize = 100;
  pageNumber = 1;
  search = "";
}

export enum Ltype {
  Purvardha_charitra,
  Uttarardha_charitra,
  Adnyat_charitra,
  Sri_Krushna_charitra,
  Sahyandra_charitre,
  Rudhapur_charitre,
  Smruti_sthal_ani_Rudhachar,
  Ridhapur_charitra_purvardha,
  Ridhapur_charitra_uttarardha
}

export class Pagination {
  constructor(
    pageNumber: number,
    pageSize: number,
    content: LAccordion[],
    remainingCount: number
  ) {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.content = content
    this.remainingCount = remainingCount
  }
  pageNumber: number;
  pageSize: number;
  content: LAccordion[];
  remainingCount: number;
}

export class LAccordion {
  constructor(
    id: number,
    title: string,
    leela: string,
    leelaOf: string,
    signiture: string,
    keywords: string,
    city: string,
    sthan: string
  ) {
    this.id = id;
    this.title = title;
    this.leela = leela;
    this.leelaOf = leelaOf;
    this.signiture = signiture;
    this.keywords = keywords;
    this.city = city;
    this.sthan = sthan
  }
  id: number;
  title: string;
  leela: string;
  leelaOf: string;
  signiture: string;
  keywords: string;
  city: string;
  sthan: string;
}